import {getInputPlaceHolder, getSelectPlaceHolder} from 'utils/message-helper';
import {Button, Typography} from 'antd';
import PropTypes from 'prop-types';
import React, {useState} from 'react';
import formConfig from 'utils/form-config';
import AppCard from '../layouts/app-card';
import {useFormContext} from 'react-hook-form';
import AppInput from '../controles/input';
import AppSelect from '../controles/select';

const CompanyInfoForm = ({onContinue, isLoading}) => {
  const {trigger} = useFormContext();
  const handleOnSubmit = async () => {
    const isValid = await trigger([
      'name',
      'website',
      'company_size',
      'phone_number',
      'role',
      'promo_code',
    ]);
    if (isValid) {
      onContinue();
    }
  };

  const [showPromo, setShowPromo] = useState(false);

  return (
    <AppCard className='bg-[#FFFFFF6B] p-5'>
      <div className='flex flex-col items-center'>
        <Typography.Title>Company Details</Typography.Title>
        <Typography.Paragraph>
          Share more information with us about your company.
        </Typography.Paragraph>
        <AppInput
          isRequired
          name='name'
          label='Company Name'
          placeholder={getInputPlaceHolder('company name')}
        />
        <AppInput
          isRequired
          name='website'
          label='Company Website'
          placeholder={getInputPlaceHolder('website')}
        />
        <AppSelect
          isRequired
          name='company_size'
          label='Company Size'
          showSearch
          placeholder={getSelectPlaceHolder('company size')}
          options={formConfig.company_size.options}
          classes={{
            root: 'md:max-w-[480px] w-full',
          }}
        />
        <AppInput
          isRequired
          type='phone'
          name='phone_number'
          label='Phone Number'
          placeholder={getInputPlaceHolder('phone number')}
        />
        <AppInput
          isRequired
          name='role'
          label='Your Role'
          placeholder={getInputPlaceHolder('role')}
        />
        {showPromo && (
          <AppInput
            name='promo_code'
            label='Promo Code'
            placeholder={getInputPlaceHolder('promo code')}
          />
        )}
        {!showPromo && (
          <div className='max-w-[480px] w-full mb-10'>
            <Typography.Link onClick={() => setShowPromo(true)}>
              I have a promo code
            </Typography.Link>
          </div>
        )}
        <Button
          loading={isLoading}
          onClick={handleOnSubmit}
          type='primary'
          size='large'
          className='mb-10 bg-[#EC8350] w-full max-w-[480px] hover:!bg-[#EC8350] hover:opacity-45'>
          Create Account
        </Button>
      </div>
    </AppCard>
  );
};

CompanyInfoForm.propTypes = {
  onContinue: PropTypes.func,
  isLoading: PropTypes.bool,
};

export default React.memo(CompanyInfoForm);
